
import request from '@/http/http'
const PREFIX='api/identity';
export function getAllRoles(){
  return request({
    url: PREFIX + '/roles/all',
  })
}
export function creatRoles(data){
  return request({
    url: PREFIX + "/roles",
    method:'post',
    data
  })
}
export function updateRoles(id,data){
  return request({
    url: PREFIX + "/roles/"+id,
    method:'put',
    data
  })
}
export function deleteRole(id){
  return request({
    url: PREFIX + "/roles/"+id,
    method:'delete',
  })
}

export function getSecurityLogs(query) {
  return request({
    url: PREFIX + '/security-logs',
    params:query,
  })
}
